// Footer content and strings
export const FOOTER_CONTENT = {
  company: {
    name: 'HSP',
    tagline: 'Your personal home maintenance team. Never climb a ladder or mow a lawn again.'
  },
  
  contact: {
    title: 'Contact Us',
    phone: '(888) 504-6944',
    email: 'hello@hsppro.com',
    location: 'San Francisco Bay area'
  },
  
  services: {
    title: 'Services',
    items: [
      { label: 'Lawn Mowing', link: '/services' },
      { label: 'Gutter Cleaning', link: '/services' },
      { label: 'Window Cleaning', link: '/services' },
      { label: 'Trash Can Cleaning', link: '/services' },
      { label: 'Power Washing', link: '/services' }
    ]
  },
  
  quickLinks: {
    title: 'Quick Links',
    items: [
      { label: 'About Us', link: '/about' },
      { label: 'Our Services', link: '/services' },
      { label: 'Workshops', link: '/workshops' },
      { label: 'FAQ', link: '/faq' },
      { label: 'Start Membership', link: '/signup' }
    ]
  },
  
  social: {
    facebook: 'https://www.facebook.com/hammersawpaint',
    twitter: 'https://x.com/hammersawpaint',
    instagram: 'https://www.instagram.com/hammersawpaint'
  },
  
  legal: {
    copyright: `© ${new Date().getFullYear()} HSP Pro, LLC. All rights reserved.`,
    links: [
      { label: 'Sitemap', link: '/sitemap' },
      { label: 'Privacy Policy', link: '/privacy-policy' },
      { label: 'Terms of Service', link: '/terms-of-service' },
      { label: 'Cancellation Policy', link: '/cancellation-policy' }
    ]
  }
};
